document.addEventListener("DOMContentLoaded", () => {

  /* ---------- ELEMENTS ---------- */

  const step1 = document.getElementById("step1");
  const step2 = document.getElementById("step2");
  const step3 = document.getElementById("step3");

  const subheading = document.getElementsByClassName("ww-subheading")[0];
  const success  = document.getElementById("success");
  const progress = document.querySelector("#progressBar");
  const card     = document.querySelector(".ww-card");

  const steps = [step1, step2, step3];

  /* Step 1 — Business information */
  const business          = document.getElementById("business");
  const businessOther     = document.getElementById("businessOther");
  const company           = document.getElementById("company");
  const legalName         = document.getElementById("legalName");
  const businessPhone     = document.getElementById("businessPhone");
  const email             = document.getElementById("email");
  const website           = document.getElementById("website");
  const numberOfStores    = document.getElementById("stores");
  const businessFormation = document.getElementById("businessFormation");

  /* Step 1 — Primary contact */
  const first = document.getElementById("first");
  const last  = document.getElementById("last");
  const phone = document.getElementById("phone");

  /* Step 1 — Shipping address */
  const street         = document.getElementById("street");
  const unit           = document.getElementById("unit");
  const city           = document.getElementById("city");
  const postal         = document.getElementById("postal");
  const country        = document.getElementById("country");
  const provinceSelect = document.getElementById("provinceSelect");

  /* Step 1 — Billing address */
  const billingSame     = document.getElementById("billingSame");
  const billingStreet   = document.getElementById("billingStreet");
  const billingUnit     = document.getElementById("billingUnit");
  const billingCity     = document.getElementById("billingCity");
  const billingPostal   = document.getElementById("billingPostal");
  const billingProvince = document.getElementById("billingProvince");

  /* Step 2 — Uploads */
  const paymentType     = document.getElementById("paymentType");
  const businessLicense = document.getElementById("businessLicense");
  const comments        = document.getElementById("comments");
  const complianceAck   = document.getElementById("complianceAck");

  const reviewBox = document.getElementById("reviewBox");

  /* Buttons */
  const next1      = document.getElementById("next1");
  const back1      = document.getElementById("back1");
  const reviewBtn  = document.getElementById("reviewBtn");
  const edit       = document.getElementById("edit");
  const submitBtn  = document.getElementById("submit");
  const resetBtn   = document.getElementById("ww_reset_btn");


  /* ---------- STEP CONTROL ---------- */

  function setStep(i) {
    steps.forEach((s, x) => s.classList.toggle("hidden", x !== i));
    progress.style.width = (i + 1) * 33 + "%";
  }

  // Step 1 is long, so bring the top of the form back into view on
  // every step change rather than leaving the visitor at the bottom.
  function scrollToForm() {
    if (card) card.scrollIntoView({ behavior: "smooth", block: "start" });
  }


  /* ---------- ERROR UI ---------- */

  // Checkboxes live in .ww-check, not .ww-field, so they get the class on
  // the row instead (CSS: .ww-check.input-error label turns red).
  function showError(input, msg) {
    if (!input) return;

    const check = input.closest(".ww-check");
    if (check) {
      check.classList.add("input-error");
      input.classList.add("input-error");
      return;
    }

    const container = input.closest(".ww-field");
    if (!container) return;
    let e = container.querySelector(".error-text");
    if (!e) {
      e = document.createElement("div");
      e.className = "error-text";
      container.appendChild(e);
    }
    e.textContent = msg;
    e.classList.add("show");
    input.classList.add("input-error");
  }

  function clearError(input) {
    if (!input) return;

    const check = input.closest(".ww-check");
    if (check) check.classList.remove("input-error");

    const container = input.closest(".ww-field");
    if (container) {
      const e = container.querySelector(".error-text");
      if (e) e.classList.remove("show");
    }
    input.classList.remove("input-error");
  }

  function clearAllErrors() {
    document.querySelectorAll(".error-text").forEach(e => e.classList.remove("show"));
    document.querySelectorAll(".input-error").forEach(e => e.classList.remove("input-error"));
  }

  // Scroll to the first field with an error so the visitor can see what failed.
  function focusFirstError(stepEl) {
    const bad = stepEl.querySelector(".input-error");
    if (!bad) return;
    const target = bad.closest(".ww-field, .ww-check") || bad;
    target.scrollIntoView({ behavior: "smooth", block: "center" });
  }


  /* ---------- PHONE FORMAT (contact + business) ---------- */

  function bindPhoneFormat(el) {
    if (!el) return;
    el.addEventListener("input", () => {
      let v = el.value.replace(/\D/g, "").slice(0, 10);
      if (v.length > 6)      el.value = `(${v.slice(0,3)}) ${v.slice(3,6)}-${v.slice(6)}`;
      else if (v.length > 3) el.value = `(${v.slice(0,3)}) ${v.slice(3)}`;
      else                   el.value = v;
    });
  }

  bindPhoneFormat(phone);
  bindPhoneFormat(businessPhone);


  /* ---------- POSTAL FORMAT (shipping + billing) ---------- */

  function bindPostalFormat(el) {
    if (!el) return;
    el.addEventListener("input", () => {
      let v = el.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 6);
      if (v.length > 3) v = v.slice(0, 3) + " " + v.slice(3);
      el.value = v;
    });
  }

  bindPostalFormat(postal);
  bindPostalFormat(billingPostal);


  /* ---------- PROVINCE ---------- */

  function getProvince() {
    return provinceSelect.value;
  }


  /* ---------- BILLING ---------- */

  function billingIsSame() {
    return !billingSame || billingSame.checked;
  }

  // Ticked = shipping copied, the same rule as the TVB form.
  function getBilling() {
    if (billingIsSame()) {
      return {
        same:     true,
        street:   street.value,
        unit:     unit.value,
        city:     city.value,
        province: getProvince(),
        postal:   postal.value
      };
    }
    return {
      same:     false,
      street:   billingStreet.value,
      unit:     billingUnit.value,
      city:     billingCity.value,
      province: billingProvince.value,
      postal:   billingPostal.value
    };
  }


  /* ---------- VALIDATION ---------- */

  // \p{L} accepts accented letters, so Montréal, Trois-Rivières and names
  // like Zoë pass, and 2-letter names like "Al" or "Li" are allowed.
  const textRule   = /^[\p{L}\s\-'.]{2,}$/u;
  const streetRule = /^(?=.*\p{L})(?=.*\d).{5,}$/u;
  const caPostal   = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
  const emailRule  = /^\S+@\S+\.\S+$/;

  const MAX_FILE_MB = 10;
  const FILE_TYPES  = ["image/jpeg", "image/jpg", "image/png", "application/pdf"];

  function validateStep1() {
    let ok = true;

    [
      business, businessOther, company, legalName, businessPhone, email, numberOfStores,
      businessFormation, first, last, phone,
      street, unit, city, country, postal, provinceSelect,
      billingStreet, billingUnit, billingCity, billingPostal, billingProvince
    ].forEach(clearError);

    function fail(input, msg) {
      showError(input, msg);
      ok = false;
    }

    /* Business information */
    if (!business.value)                         fail(business, "Select business type");
    if (business.value === "Other" && businessOther.value.trim().length < 2)
                                                 fail(businessOther, "Tell us your business type");
    if (company.value.trim().length < 2)         fail(company, "Enter your shop name");
    if (legalName.value.trim().length < 2)       fail(legalName, "Enter the legal business name");
    if (businessPhone.value.replace(/\D/g, "").length < 10)
                                                 fail(businessPhone, "Enter valid business phone");
    if (!emailRule.test(email.value.trim()))     fail(email, "Enter valid email");
    if (!numberOfStores.value || Number(numberOfStores.value) < 1)
                                                 fail(numberOfStores, "Enter number of stores");
    if (!businessFormation.value)                fail(businessFormation, "Select business formation");

    /* Primary contact */
    if (!textRule.test(first.value.trim()))      fail(first, "Enter real first name");
    if (!textRule.test(last.value.trim()))       fail(last, "Enter real last name");
    if (phone.value.replace(/\D/g, "").length < 10)
                                                 fail(phone, "Enter valid phone");

    /* Shipping address */
    if (!streetRule.test(street.value.trim()))   fail(street, "Street must include number + name");
    if (!unit.value.trim())                      fail(unit, "Enter unit (or N/A)");
    if (!textRule.test(city.value.trim()))       fail(city, "Enter real city");
    if (!textRule.test(country.value.trim()))    fail(country, "Enter real country");

    if (country.value.trim().toLowerCase() === "canada") {
      if (!provinceSelect.value)                 fail(provinceSelect, "Select province");
      if (!caPostal.test(postal.value))          fail(postal, "Invalid Canadian postal");
    } else if (postal.value.trim().length < 3) {
      fail(postal, "Enter postal code");
    }

    /* Billing address — only when "Same as shipping" is unticked */
    if (!billingIsSame()) {
      if (!streetRule.test(billingStreet.value.trim()))
                                                 fail(billingStreet, "Street must include number + name");
      if (!billingUnit.value.trim())             fail(billingUnit, "Enter unit (or N/A)");
      if (!textRule.test(billingCity.value.trim()))
                                                 fail(billingCity, "Enter real city");
      if (!caPostal.test(billingPostal.value))   fail(billingPostal, "Invalid Canadian postal");
      if (!billingProvince.value)                fail(billingProvince, "Select province");
    }

    return ok;
  }

  function validateStep2() {
    let ok = true;
    [paymentType, businessLicense, complianceAck].forEach(clearError);

    if (!paymentType.value) {
      showError(paymentType, "Select payment type");
      ok = false;
    }

    const file = businessLicense.files && businessLicense.files[0];
    if (!file) {
      showError(businessLicense, "Upload your business licence");
      ok = false;
    } else if (FILE_TYPES.indexOf(file.type) === -1) {
      showError(businessLicense, "File must be PNG, JPG or PDF");
      ok = false;
    } else if (file.size > MAX_FILE_MB * 1024 * 1024) {
      showError(businessLicense, "File must be under " + MAX_FILE_MB + " MB");
      ok = false;
    }

    if (!complianceAck.checked) {
      showError(complianceAck, "Please accept the compliance acknowledgement");
      ok = false;
    }

    return ok;
  }


  /* ---------- DATA ---------- */

  function data() {
    const billing = getBilling();
    const file    = businessLicense.files && businessLicense.files[0];

    return {
      business:          business.value === "Other"
                           ? "Other: " + businessOther.value.trim()
                           : business.value,
      company:           company.value,
      legalName:         legalName.value,
      businessPhone:     businessPhone.value,
      email:             email.value,
      website:           website.value,
      numberOfStores:    numberOfStores.value,
      businessFormation: businessFormation.value,

      first:             first.value,
      last:              last.value,
      phone:             phone.value,

      street:            street.value,
      unit:              unit.value,
      city:              city.value,
      country:           country.value,
      province:          getProvince(),
      postal:            postal.value,

      billingSame:       billing.same ? "Yes" : "No",
      billingStreet:     billing.street,
      billingUnit:       billing.unit,
      billingCity:       billing.city,
      billingProvince:   billing.province,
      billingPostal:     billing.postal,

      paymentType:       paymentType.value,
      businessLicense:   file ? file.name : "",
      comments:          comments.value,
      compliance:        complianceAck.checked ? "Accepted" : ""
    };
  }


  /* ---------- CUSTOM DROPDOWNS ---------- */

  // Force dark background on all selects
  function updateSelectColor(select) {
    select.style.setProperty('background', '#000000', 'important');
    select.style.setProperty('color',
      select.value === '' ? 'rgba(255,255,255,0.40)' : 'rgba(255,255,255,0.90)',
      'important'
    );
  }

  document.querySelectorAll('.ww-field select').forEach(function (select) {
    updateSelectColor(select);
    select.addEventListener('change', function () { updateSelectColor(select); });
  });

  function buildWwDropdown(selectEl) {
    const wrapper = selectEl.closest('.ww-field');
    if (!wrapper || wrapper.dataset.customDropdown) return;
    wrapper.dataset.customDropdown = 'true';
    wrapper.style.position = 'relative';

    const display = document.createElement('div');
    display.className = 'ww-custom-dropdown__display';

    function syncDisplay() {
      const selected = selectEl.options[selectEl.selectedIndex];
      display.textContent = selected ? selected.text : '';
      display.style.color = (!selectEl.value || selectEl.value === '')
        ? 'rgba(255,255,255,0.40)'
        : 'rgba(255,255,255,0.90)';
    }
    syncDisplay();

    const listEl = document.createElement('div');
    listEl.className = 'ww-dropdown-list hidden';

    function buildOptions() {
      listEl.innerHTML = '';
      Array.from(selectEl.options).forEach(function (opt) {
        // Skip the disabled placeholder so it can't be picked as an answer.
        if (opt.disabled && opt.value === '') return;
        const item = document.createElement('div');
        item.className = 'ww-dropdown-option';
        item.textContent = opt.text;
        item.addEventListener('mousedown', function (e) {
          e.preventDefault();
          selectEl.value = opt.value;
          selectEl.dispatchEvent(new Event('change', { bubbles: true }));
          syncDisplay();
          listEl.classList.add('hidden');
        });
        listEl.appendChild(item);
      });
    }
    buildOptions();

    display.addEventListener('click', function (e) {
      e.stopPropagation();
      const isHidden = listEl.classList.contains('hidden');
      document.querySelectorAll('.ww-dropdown-list').forEach(d => d.classList.add('hidden'));
      if (isHidden) listEl.classList.remove('hidden');
    });

    document.addEventListener('click', function () {
      listEl.classList.add('hidden');
    });

    new MutationObserver(function () {
      buildOptions();
      syncDisplay();
    }).observe(selectEl, { childList: true });

    selectEl.style.display = 'none';
    wrapper.insertBefore(display, selectEl);
    wrapper.appendChild(listEl);

    selectEl.addEventListener('change', function () {
      syncDisplay();
      clearError(selectEl);
    });
  }

  document.querySelectorAll('.ww-field select').forEach(function (select) {
    buildWwDropdown(select);
  });

  // Clear a checkbox's red state as soon as it is ticked.
  if (complianceAck) {
    complianceAck.addEventListener("change", function () {
      if (complianceAck.checked) clearError(complianceAck);
    });
  }


  /* ---------- REVIEW ---------- */

  // Values are visitor input, so escape them before they go into innerHTML.
  function esc(v) {
    return String(v)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function review() {
    const d = data();

    const groups = [
      ["Business information", [
        ["Business type",       d.business],
        ["Shop name",           d.company],
        ["Legal business name", d.legalName],
        ["Business phone",      d.businessPhone],
        ["Business email",      d.email],
        ["Website",             d.website],
        ["Number of stores",    d.numberOfStores],
        ["Business formation",  d.businessFormation]
      ]],
      ["Primary contact", [
        ["First name",          d.first],
        ["Last name",           d.last],
        ["Phone",               d.phone]
      ]],
      ["Shipping address", [
        ["Street address",      d.street],
        ["Unit",                d.unit],
        ["City",                d.city],
        ["Province",            d.province],
        ["Postal code",         d.postal],
        ["Country",             d.country]
      ]],
      ["Billing address", d.billingSame === "Yes"
        ? [["Billing address",  "Same as shipping"]]
        : [
            ["Street address",  d.billingStreet],
            ["Unit",            d.billingUnit],
            ["City",            d.billingCity],
            ["Province",        d.billingProvince],
            ["Postal code",     d.billingPostal]
          ]
      ],
      ["Uploads", [
        ["Payment type",        d.paymentType],
        ["Business licence",    d.businessLicense],
        ["Comments",            d.comments],
        ["Compliance",          d.compliance]
      ]]
    ];

    reviewBox.innerHTML = groups.map(function ([title, rows]) {
      return '<div class="ww-review-group"><p><b>' + esc(title) + '</b></p>' +
        rows.map(function ([label, value]) {
          return '<div>' + esc(label) + ': ' + (value ? esc(value) : '—') + '</div>';
        }).join('') +
        '</div>';
    }).join('');
  }


  /* ---------- NAV ---------- */

  next1.onclick = () => {
    if (validateStep1()) {
      setStep(1);
      scrollToForm();
    } else {
      focusFirstError(step1);
    }
  };

  back1.onclick = () => {
    setStep(0);
    scrollToForm();
  };

  reviewBtn.onclick = () => {
    if (validateStep2()) {
      review();
      setStep(2);
      scrollToForm();
    } else {
      focusFirstError(step2);
    }
  };

  // Most fields are on step 1, so Edit goes back to the start.
  edit.onclick = () => {
    setStep(0);
    scrollToForm();
  };


  /* ---------- SUBMIT ---------- */

  const RemoteUrl = 'https://emailservice.nashavape.com/api/email/send/wholesale-request';

  function readFile(input, field) {
    const file = input && input.files && input.files[0];
    if (!file) return Promise.resolve(null);
    return new Promise(function (resolve) {
      const reader = new FileReader();
      reader.onload = function () {
        resolve({ field: field, name: file.name, type: file.type, size: file.size, data: reader.result });
      };
      reader.onerror = function () { resolve(null); };
      reader.readAsDataURL(file);
    });
  }

  submitBtn.addEventListener("click", function () {

    clearAllErrors();

    const btn = submitBtn.querySelector("button") || submitBtn;
    btn.disabled = true;
    btn.textContent = "Submitting...";

    // Re-check both steps. If one fails, show that step so the errors are
    // visible instead of failing silently on the hidden review screen.
    if (!validateStep1()) {
      setStep(0);
      focusFirstError(step1);
      btn.disabled = false;
      btn.textContent = "Submit";
      return;
    }
    if (!validateStep2()) {
      setStep(1);
      focusFirstError(step2);
      btn.disabled = false;
      btn.textContent = "Submit";
      return;
    }

    const NA = "N/A";
    const d  = data();
    const t  = v => (v || "").toString().trim();
    const complianceText = complianceAck.checked ? complianceAck.value : "";

    const formData = new FormData();
    formData.append("FromEmail", "internal@thevapebusiness.com");
    formData.append("ToEmail",   "signups@thevapebusiness.com");
    formData.append("source",    "Nasha");

    // --- Original keys ---
    formData.append("FirstName",      t(d.first)          || NA);
    formData.append("LastName",       t(d.last)           || NA);
    formData.append("Email",          t(d.email)          || NA);
    formData.append("Phone",          t(d.phone)          || NA);
    formData.append("BusinessType",   d.business          || NA);
    formData.append("CompanyName",    t(d.company)        || NA);
    formData.append("NumberOfStores", t(d.numberOfStores) || NA);
    formData.append("StreetAddress",  t(d.street)         || NA);
    formData.append("Unit",           t(d.unit)           || NA);
    formData.append("City",           t(d.city)           || NA);
    formData.append("PostalCode",     t(d.postal)         || NA);
    formData.append("Country",        t(d.country)        || NA);
    formData.append("Province",       t(d.province)       || NA);
    formData.append("Comments",       t(d.comments)       || "No comments provided.");

    // --- New keys, same names as the Boosted and TVB forms ---
    formData.append("OperatingAs",           t(d.legalName)         || NA);
    formData.append("BusinessPhone",         t(d.businessPhone)     || NA);
    formData.append("WebsiteUrl",            t(d.website)           || "None");
    formData.append("BusinessFormation",     d.businessFormation    || NA);
    formData.append("BillingSameAsShipping", d.billingSame);
    formData.append("BillingStreetAddress",  t(d.billingStreet)     || NA);
    formData.append("BillingUnit",           t(d.billingUnit)       || NA);
    formData.append("BillingCity",           t(d.billingCity)       || NA);
    formData.append("BillingProvince",       t(d.billingProvince)   || NA);
    formData.append("BillingPostalCode",     t(d.billingPostal)     || NA);
    formData.append("PaymentType",           d.paymentType          || NA);
    formData.append("AgreementOption",       complianceText);

    const licence = businessLicense.files[0];
    if (licence) {
      formData.append("formFiles", licence, "BusinessLicense-" + licence.name);
    }

    /* ---------- SEND TO BXRS (readable labels) ---------- */
    var bxrsFields = {
      "Business type":            d.business                || NA,
      "Shop name":                t(d.company)              || NA,
      "Legal business name":      t(d.legalName)            || NA,
      "Business phone":           t(d.businessPhone)        || NA,
      "Email":                    t(d.email)                || NA,
      "Website":                  t(d.website)              || "None",
      "Number of stores":         t(d.numberOfStores)       || NA,
      "Business formation":       d.businessFormation       || NA,
      "First name":               t(d.first)                || NA,
      "Last name":                t(d.last)                 || NA,
      "Phone":                    t(d.phone)                || NA,
      "Street address":           t(d.street)               || NA,
      "Unit":                     t(d.unit)                 || NA,
      "City":                     t(d.city)                 || NA,
      "Province":                 t(d.province)             || NA,
      "Postal code":              t(d.postal)               || NA,
      "Country":                  t(d.country)              || NA,
      "Billing same as shipping": d.billingSame,
      "Billing street address":   t(d.billingStreet)        || NA,
      "Billing unit":             t(d.billingUnit)          || NA,
      "Billing city":             t(d.billingCity)          || NA,
      "Billing province":         t(d.billingProvince)      || NA,
      "Billing postal code":      t(d.billingPostal)        || NA,
      "Payment type":             d.paymentType             || NA,
      "Agreement":                complianceText            || NA,
      "Comments":                 t(d.comments)             || "No comments provided."
    };

    readFile(businessLicense, "Business License Upload").then(function (file) {
      return fetch('https://bxrs.ca/api/wholesale/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Wholesale-Key': 'bf8f6ac654f16ed5e77f62f303381827b8fdcdada6c7c40c' },
        body: JSON.stringify({ fields: bxrsFields, files: file ? [file] : [], page: location.href }),
      });
    }).catch(function () {});

    fetch(RemoteUrl, { method: "POST", body: formData })
      .then(function (response) {
        if (!response.ok) {
          return response.text().then(function (body) {
            throw new Error("Server error " + response.status + ": " + body);
          });
        }
        return response.text();
      })
      .then(function () {
        step1.classList.add("hidden");
        step2.classList.add("hidden");
        step3.classList.add("hidden");
        if (subheading) subheading.classList.add("hidden");
        success.classList.remove("hidden");
        progress.style.width = "100%";
        window.scrollTo({ top: 0, behavior: "smooth" });
      })
      .catch(function (error) {
        console.error("Submission error:", error.message);
        alert("Submission failed: " + error.message);
      })
      .finally(function () {
        btn.disabled = false;
        btn.textContent = "Submit";
      });

  });


  /* ---------- RESET / RE-OPEN ---------- */

  if (resetBtn) {
    resetBtn.addEventListener("click", function () {
      // Clear text inputs, file input and textareas. Checkboxes are skipped:
      // setting .value on them wipes their value attribute (the compliance
      // text), so they are reset by .checked below instead.
      document.querySelectorAll(".ww-card input, .ww-card textarea").forEach(function (el) {
        if (el.type === "checkbox" || el.type === "radio") return;
        el.value = "";
      });

      if (complianceAck) complianceAck.checked = false;
      if (billingSame) {
        billingSame.checked = true;
        // The section's inline script listens for this and hides + disables
        // the billing block again.
        billingSame.dispatchEvent(new Event("change", { bubbles: true }));
      }

      // Reset selects to their placeholder and re-sync the custom dropdowns.
      // This also hides the "Other" text box again.
      document.querySelectorAll(".ww-card select").forEach(function (sel) {
        sel.selectedIndex = 0;
        sel.dispatchEvent(new Event("change", { bubbles: true }));
      });

      clearAllErrors();

      // Re-gate the province field
      if (provinceSelect) provinceSelect.classList.add("hidden");

      // Back to step 1
      success.classList.add("hidden");
      if (subheading) subheading.classList.remove("hidden");
      setStep(0);
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }
});